import React, { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import Frota from './components/Frota';
import Motoristas from './components/Motoristas';
import Manutencoes from './components/Manutencoes';
import Contratos from './components/Contratos';
import Financeiro from './components/Financeiro';
import Abastecimento from './components/Abastecimento';
import Rastreamento from './components/Rastreamento';
import ResumoDia from './components/ResumoDia';
import Relatorios from './components/Relatorios';
import api from './services/api';

export default function App() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState(null);
  const [userRole, setUserRole] = useState('admin');
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuAberto, setMenuAberto] = useState(false);
  const [error, setError] = useState('');

  const [frotaList, setFrotaList] = useState([]);
  const [motoristasList, setMotoristasList] = useState([]);
  const [manutencoesList, setManutencoesList] = useState([]);
  const [contratosList, setContratosList] = useState([]);
  const [financeiroList, setFinanceiroList] = useState([]);
  const [abastecimentosList, setAbastecimentosList] = useState([]);

  const carregarDados = async () => {
    try {
      const [frota, motoristas, manutencoes, contratos, financeiro, abastecimento] = await Promise.all([
        api.get('/frota'),
        api.get('/motoristas'),
        api.get('/manutencoes'),
        api.get('/contratos'),
        api.get('/financeiro'),
        api.get('/abastecimento')
      ]);
      setFrotaList(frota.data || []);
      setMotoristasList(motoristas.data || []);
      setManutencoesList(manutencoes.data || []);
      setContratosList(contratos.data || []);
      setFinanceiroList(financeiro.data || []);
      setAbastecimentosList(abastecimento.data || []);
    } catch (err) {
      console.error("Erro ao sincronizar com o banco de dados:", err);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    if (!token) {
      return () => window.removeEventListener('resize', handleResize);
    }

    // Atualiza imediatamente ao entrar/trocar de módulo.
    carregarDados();

    // Mantém Dashboard, Financeiro, Frota, Contratos e Resumo sincronizados.
    const sincronizador = setInterval(() => {
      carregarDados();
    }, 5000);

    return () => {
      clearInterval(sincronizador);
      window.removeEventListener('resize', handleResize);
    };
  }, [token, activeTab]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await api.post('/auth/login', { email, password });
      const { access_token, user } = response.data;
      
      setToken(access_token);
      setUserRole(user.role);
      
      if (user.role === 'motorista') {
        setActiveTab('rastreamento');
      } else {
        setActiveTab('dashboard');
      }
    } catch (err) {
      console.error(err);
      setError('E-mail ou senha incorretos.');
    }
  };

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'frota', label: 'Frota' },
    { id: 'motoristas', label: 'Motoristas' },
    { id: 'manutencoes', label: 'Manutenções' },
    { id: 'contratos', label: 'Contratos' },
    { id: 'financeiro', label: 'Financeiro' },
    { id: 'abastecimento', label: 'Abastecimento' },
    { id: 'rastreamento', label: 'GPS' },
    { id: 'resumo', label: 'Resumo do Dia' },
    { id: 'relatorios', label: 'Relatórios' }
  ];

  if (token) {
    return (
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', height: '100vh', backgroundColor: '#000', color: '#fff', fontFamily: 'sans-serif', overflow: 'hidden' }}>
        
        {/* BARRA SUPERIOR INTELIGENTE PARA CELULAR */}
        {isMobile ? (
          <header style={{ backgroundColor: '#0a0a0a', borderBottom: '1px solid #1f1f1f', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ backgroundColor: '#fff', color: '#000', fontWeight: '900', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>PS</div>
              <h1 style={{ fontWeight: '800', fontSize: '13px', margin: 0 }}>PS TRANSPORTES</h1>
            </div>
            <button onClick={() => setMenuAberto(!menuAberto)} style={{ padding: '6px 12px', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' }}>
              {menuAberto ? '✕ Fechar Menu' : '☰ Menu'}
            </button>
          </header>
        ) : null}

        {/* MENU LATERAL (DESKTOP) OU MENU SUSPENSO (MOBILE) */}
        {(!isMobile || menuAberto) && (
          <aside style={{ 
            width: isMobile ? '100%' : '260px', 
            backgroundColor: '#0a0a0a', 
            borderRight: !isMobile && '1px solid #1f1f1f', 
            borderBottom: isMobile && '1px solid #1f1f1f', 
            padding: '16px', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between', 
            flexShrink: 0, 
            maxHeight: isMobile ? '50vh' : 'none',
            overflowY: 'auto',
            zIndex: 100
          }}>
            <div>
              {!isMobile && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '25px', paddingLeft: '8px' }}>
                  <div style={{ backgroundColor: '#fff', color: '#000', fontWeight: '900', padding: '4px 8px', borderRadius: '4px', fontSize: '14px' }}>PS</div>
                  <div>
                    <h1 style={{ fontWeight: '800', fontSize: '13px', margin: 0, letterSpacing: '0.5px' }}>PS TRANSPORTES</h1>
                    <span style={{ fontSize: '10px', color: '#777', textTransform: 'uppercase', letterSpacing: '1px' }}>Controle Total OS</span>
                  </div>
                </div>
              )}

              <nav style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
                {userRole === 'admin' ? (
                  menuItems.map(tab => (
                    <div 
                      key={tab.id} 
                      onClick={() => { setActiveTab(tab.id); if(isMobile) setMenuAberto(false); }} 
                      style={{ 
                        padding: '10px 12px', 
                        backgroundColor: activeTab === tab.id ? '#007AFF' : 'transparent', 
                        color: activeTab === tab.id ? '#fff' : '#999', 
                        borderRadius: '6px', 
                        cursor: 'pointer', 
                        fontWeight: activeTab === tab.id ? 'bold' : 'normal'
                      }}
                    >
                      {tab.label}
                    </div>
                  ))
                ) : (
                  <div onClick={() => setActiveTab('rastreamento')} style={{ padding: '10px 12px', backgroundColor: '#007AFF', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>Rastreamento (Motorista)</div>
                )}
              </nav>
            </div>

            <div style={{ borderTop: '1px solid #1f1f1f', paddingTop: '15px', marginTop: '15px' }}>
              <button onClick={() => { setToken(null); setEmail(''); setPassword(''); }} style={{ width: '100%', padding: '10px', backgroundColor: 'transparent', color: '#FF3B30', border: '1px solid #FF3B30', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', textAlign: 'left' }}>🚪 Sair da Central</button>
            </div>
          </aside>
        )}

        {/* CONTEÚDO PRINCIPAL */}
        <main style={{ flex: 1, padding: isMobile ? '16px' : '30px', overflowY: 'auto', backgroundColor: '#000' }}>
          {userRole === 'admin' && activeTab === 'dashboard' && <Dashboard frotaList={frotaList} financeiroList={financeiroList} contratosList={contratosList} setActiveTab={setActiveTab} />}
          {userRole === 'admin' && activeTab === 'frota' && <Frota frotaList={frotaList} setFrotaList={setFrotaList} motoristasList={motoristasList} />}
          {userRole === 'admin' && activeTab === 'motoristas' && <Motoristas motoristasList={motoristasList} setMotoristasList={setMotoristasList} frotaList={frotaList} />}
          {userRole === 'admin' && activeTab === 'manutencoes' && <Manutencoes manutencoesList={manutencoesList} setManutencoesList={setManutencoesList} frotaList={frotaList} />}
          {userRole === 'admin' && activeTab === 'contratos' && <Contratos contratosList={contratosList} setContratosList={setContratosList} frotaList={frotaList} motoristasList={motoristasList} />}
          {userRole === 'admin' && activeTab === 'financeiro' && <Financeiro financeiroList={financeiroList} setFinanceiroList={setFinanceiroList} />}
          {userRole === 'admin' && activeTab === 'abastecimento' && <Abastecimento abastecimentosList={abastecimentosList} setAbastecimentosList={setAbastecimentosList} frotaList={frotaList} />}
          {activeTab === 'rastreamento' && <Rastreamento frotaList={frotaList} userRole={userRole} />}
          {userRole === 'admin' && activeTab === 'resumo' && <ResumoDia frotaList={frotaList} contratosList={contratosList} financeiroList={financeiroList} manutencoesList={manutencoesList} abastecimentosList={abastecimentosList} />}
          {userRole === 'admin' && activeTab === 'relatorios' && <Relatorios frotaList={frotaList} motoristasList={motoristasList} contratosList={contratosList} financeiroList={financeiroList} manutencoesList={manutencoesList} abastecimentosList={abastecimentosList} />}
        </main>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: '100vh', flexDirection: isMobile ? 'column' : 'row', backgroundColor: '#000', color: '#fff', fontFamily: 'sans-serif' }}>
      <div style={{ flex: 1, backgroundImage: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.9)), url("/frota.jpg")', backgroundSize: 'cover', backgroundPosition: 'center', display: isMobile ? 'none' : 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '60px' }}>
        <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#888', marginBottom: '12px' }}>Sistema de Gestão Logística</div>
        <h1 style={{ fontSize: '42px', fontWeight: '900', lineHeight: '1.1', maxWidth: '600px', marginBottom: '20px' }}>Controle total da sua frota em uma só tela.</h1>
      </div>

      <div style={{ width: isMobile ? '100%' : '480px', backgroundColor: '#0a0a0a', padding: isMobile ? '30px 20px' : '50px', display: 'flex', flexDirection: 'column', justifyContent: 'center', borderLeft: '1px solid #1f1f1f', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '30px' }}>
          <div style={{ backgroundColor: '#fff', color: '#000', fontWeight: '900', padding: '6px 10px', borderRadius: '4px', fontSize: '16px' }}>PS</div>
          <div>
            <h2 style={{ fontSize: '15px', fontWeight: '800', margin: 0 }}>PS TRANSPORTES</h2>
            <span style={{ fontSize: '11px', color: '#777', textTransform: 'uppercase', letterSpacing: '1px' }}>Acesso Restrito</span>
          </div>
        </div>

        <h3 style={{ fontSize: '24px', fontWeight: '800', marginBottom: '8px' }}>Entrar na central</h3>
        <p style={{ color: '#888', fontSize: '13px', marginBottom: '25px' }}>Use suas credenciais operacionais.</p>

        {error && <p style={{ color: '#FF3B30', fontSize: '13px', marginBottom: '15px' }}>{error}</p>}

        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px', letterSpacing: '1px' }}>E-mail</label>
            <input type="email" placeholder="voce@empresa.com" value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%', padding: '14px', borderRadius: '6px', backgroundColor: '#141414', border: '1px solid #333', color: '#fff', fontSize: '14px', boxSizing: 'border-box' }} required />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '11px', textTransform: 'uppercase', color: '#888', fontWeight: 'bold', marginBottom: '6px', letterSpacing: '1px' }}>Senha</label>
            <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%', padding: '14px', borderRadius: '6px', backgroundColor: '#141414', border: '1px solid #333', color: '#fff', fontSize: '14px', boxSizing: 'border-box' }} required />
          </div>

          <button type="submit" style={{ width: '100%', padding: '14px', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer', marginTop: '10px' }}>Entrar</button>
        </form>
      </div>
    </div>
  );
}